// extracted by mini-css-extract-plugin
export var banner = "_ix-0";
export var closeButton = "_ix-2";
export var greenCheckmark = "_ix-3";
export var hereLink = "_ix-4";
export var titleIcon = "_ix-1";